import React from 'react';
import { Field, Formik } from 'formik';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Button, Toggler } from '@components';
import { TermoMAIInitialValues, TermoMAISchema } from '@schemas';
import { enviaFormRequest } from '@store/user/actions';

export const TermoMAI = ({ title, reference }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <div className="card">
      <div className="card-body">
        <h3 className="fw-bold ts-20 mb-32">{title}</h3>
        <Formik
          validateOnMount
          initialValues={TermoMAIInitialValues}
          validationSchema={TermoMAISchema}
          onSubmit={(values) => {
            dispatch(
              enviaFormRequest({
                campos: values,
                formulario: reference,
                navigate,
              })
            );
          }}
        >
          {({ handleSubmit, isValid }) => (
            <form onSubmit={handleSubmit}>
              <div className="row">
                <Field
                  className="mb-3"
                  name="solicitacao"
                  component={Toggler}
                  label={
                    <>
                      <p className="mb-2">
                        Venho, por meio deste, plenamente ciente das implicações
                        do presente ato, por livre e espontânea vontade, nos
                        termos do estipulado no art. 69 do Regulamento do Plano
                        Misto de Benefícios Previdenciários da Fundação
                        Forluminas de Seguridade Social - FORLUZ, com as
                        alterações aprovadas pela Portaria SPC nº 3.042,
                        publicada em 24 de setembro de 2009, formalizar a opção
                        pela aplicação, à minha situação jurídica e à de meus
                        beneficiários, das disposições dos artigos 24, caput e §
                        2º; 27, § 3º; 28, IV, VII e §§ 1º e 5º; 45, IV; 46, III
                        e § 1º; 47, caput e § 1º; 49, § 4º; 51, I, II e §§ 1º e
                        2º; 64, caput,, em sua atual redação.
                      </p>
                      <p className="mb-2">
                        Declaro ter recebido os textos integrais do Regulamento,
                        em sua versão anterior e atual.
                      </p>
                      <p className="mb-2">
                        Reconheço que, em razão do presente ato jurídico de
                        opção, ficam extintos meus direitos, e os de meus
                        beneficiários, decorrentes do conteúdo dos
                        correspondentes artigos, incisos e parágrafos, em suas
                        redações anteriores, renunciando, portanto, a todos os
                        direitos, pretensões e ações decorrentes, para nada mais
                        reclamar, em tempo algum, no tocante a eles.
                      </p>
                      <p className="mb-2">
                        Obrigo-me a renunciar a direitos postulados em processos
                        judiciais que se refiram aos aqui pactuados,
                        encaminhando cópia da petição devidamente protocolada à
                        FORLUZ, com o respectivo pedido de desistência. Estou
                        ciente que o presente &quot;termo de opção&quot; só será
                        aceito e produzirá efeitos após a entrega à FORLUZ da
                        decisão do juízo acatando o mencionado pedido.
                      </p>
                    </>
                  }
                />
              </div>

              <hr className="mt-32 mt-xs-0 mb-32" />

              <div className="row">
                <div className="col-12 col-md-6 col-xl-4 ms-0 ms-md-auto">
                  <div className="d-block d-md-flex align-items-center">
                    <Button
                      disabled={!isValid}
                      className="ms-0 ms-md-3"
                      onClick={handleSubmit}
                    >
                      Continuar
                    </Button>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};
